import { Dropdown } from "primereact/dropdown";
import React from "react";

export default function DropDown({
	style = null,
	label,
	optionLabel,
	optionValue,
	value,
	onChange,
	error,
	options = [],
	required = false,
	showClear = false
}) {
	return (
		<div style={style} className="form-control">
			{label} {required ? <span style={{ color: "red" }}>*</span> : ""}
			<Dropdown
				required
				optionLabel={optionLabel}
				optionValue={optionValue}
				value={value}
				options={options}
				onChange={onChange}
				style={{ width: "100%" }}
				placeholder={`${value}`}
				showClear={showClear}
			/>
			<small className="p-error">{error}</small>
		</div>
	);
}
